import { apiClient } from '../../ruutsApi/client'
import endpoints from '../../ruutsApi/endpoints'
import { unwrapVoid } from '../../ruutsApi/normalize'

// Both DELETE endpoints answer 500 (not 404) when nothing matches — a possible,
// non-exceptional outcome for already-deleted strata. Errors propagate as-is and
// the mutation layer must not retry them.
export const deleteSamplingAreas = async ({
  entities,
}: {
  entities: { id: string }[]
}): Promise<void> => {
  const ids = entities.map(entity => entity.id)
  const response = await apiClient.delete(endpoints.samplingAreas, { data: { ids } })
  return unwrapVoid(response)
}

export const deleteSamplingAreasByFarm = async ({ farmId }: { farmId: string }): Promise<void> => {
  const response = await apiClient.delete(`${endpoints.samplingAreas}/farms/${farmId}`)
  return unwrapVoid(response)
}
